import { lazy } from "react";
import { Navigate } from "react-router-dom";
const UserView = lazy(() => import("../../views/apps/user/view"));
const Users = lazy(() => import("../../views/news/admin/users"));
const Events = lazy(() => import("../../views/news/admin/events"));
const Logs = lazy(() => import("../../views/news/admin/logs"));
const PricingEngine = lazy(() =>
  import("../../views/news/admin/pricing-engine")
);

const AdminRoutes = [
  {
    path: "/apps/user/view",
    element: <Navigate to="/apps/user/view/1" />,
  },
  {
    element: <Users />,
    path: "/users",
  },
  {
    element: <UserView />,
    path: "/apps/user/view/:id",
  },
  {
    element: <PricingEngine />,
    path: "/pricing-engine",
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/logs",
    element: <Logs />,
  },
];

export default AdminRoutes;
